// Source of truth for the pre-analysis wizard dropdowns.
//
// Each option carries a hidden `value` and a user-facing `label`. The `value`
// is the AUTHORITATIVE stage-labeled string the backend maps to an OCS phase
// (the stage prefix before the colon is the selector — see
// backend/app/services/ai/ocs.py and GOAL_TO_PHASE). The `label` is
// outcome-oriented copy with the ASLAN capability intentionally hidden from the
// user (client request, 6/16) — so the UX stays simple while the methodology
// mapping is preserved behind the scenes.

export interface WizardOption {
  value: string;
  label: string;
}

export const PRIMARY_GOAL_OPTIONS: WizardOption[] = [
  { value: "Engage: Earn an initial conversation", label: "Earn an Initial Conversation" },
  { value: "Engage: Re-engage a stalled opportunity", label: "Re-engage a Stalled Opportunity" },
  { value: "Discover: Understand their needs and priorities", label: "Understand Needs and Priorities" },
  { value: "Build Value: Share insight, information, or a proposal", label: "Share Insight or Recommendation" },
  { value: "Build Value: Present information or a proposal", label: "Present Information or a Proposal" },
  { value: "Build Value: Address a solution concern or pricing objection", label: "Address a Solution or Pricing Concern" },
  { value: "Advance: Gain a commitment to a next step", label: "Gain Commitment to a Next Step" },
];

// "What is the prospect's current level of receptivity?" — a High/Medium/Low
// signal the backend passes to the LLM to drive capability emphasis (Low =
// lead with Engage / drop-the-rope regardless of the selected goal). It no
// longer selects the stage (BUG-004). value === label here.
export const RECEPTIVITY_OPTIONS: WizardOption[] = [
  { value: "High", label: "High" },
  { value: "Medium", label: "Medium" },
  { value: "Low", label: "Low" },
];

// The conditional "whiteboard" question only shows for early-stage goals
// (Engage/Discover), where knowing the prospect's current priorities matters
// most (per client feedback items 5 & 7.1). Reads the hidden value's stage
// prefix, so it is unaffected by the user-facing label copy.
export function showsWhiteboard(primaryGoal: string): boolean {
  const stage = primaryGoal.split(":", 1)[0]?.trim();
  return stage === "Engage" || stage === "Discover";
}
